import React from 'react';
import ScrapingShell from '../../../components/ScrapingShell';

/** Manager V2 Recruit — Phase 2 shell. Feature : pages.recruitment.manager. */
const ManagerV2Recruit = () => (
  <ScrapingShell
    titleKey="recruitV2.managerTitle" titleFallback="Recruit"
    bodyKey="recruitV2.managerBody"
    bodyFallback="Manager-level recruitment (lead lists, live-check) depends on the scraping pipeline (Phase 2). Enabled per tenant once wired."
  />
);

export default ManagerV2Recruit;
